import { Spacer } from "@qivia/ui";
import { useParams } from "react-router-dom";

export const MonthlyReportsTab = () => {
  const params = useParams();

  //TODO HANDLE PERMISSIONS FOR SEES AND CREATE MONTHLY REPORTS

  if (params.tab !== "monthly_reports") {
    return;
  }

  return (
    <>
      <Spacer y={2} />
      <div>Contenu des rapports mensuels à venir.</div>
    </>
  );
};
